import { Container, useTheme } from "@mui/material";

export default function NTContainer({ children }) {
  const theme = useTheme();

  return (
    <Container
      sx={{
        mb: "140px",
        pt: "80px",
        [theme.breakpoints.down("md")]: {
          p: 0,
          mb: 0,
        },
      }}
    >
      {children}
    </Container>
  );
}
